import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import sk from './sk';
import en from './en';
import de from './de';
import uk from './uk';
import ru from './ru';
import serviceMedia from '../data/services';

const dictionaries = { sk, en, de, uk, ru };
const list = [sk, en, de, uk, ru];
const STORAGE_KEY = 'sparklean_lang';

const LanguageContext = createContext({
  code: 'sk',
  setCode: () => {},
  t: (key) => key,
  languages: list,
  services: []
});

const hydrateServices = (dict) => {
  const map = new Map(serviceMedia.map((s) => [s.slug, s]));
  return (dict.services || []).map((svc) => ({
    ...svc,
    ...(map.get(svc.slug) || {})
  }));
};

const resolve = (obj, path) => path.split('.').reduce((acc, segment) => (acc ? acc[segment] : undefined), obj);

export const LanguageProvider = ({ children }) => {
  const [code, setCode] = useState(() => {
    const saved = typeof window !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null;
    return saved && dictionaries[saved] ? saved : 'sk';
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    localStorage.setItem(STORAGE_KEY, code);
    document.documentElement.lang = code;
  }, [code]);

  const value = useMemo(() => {
    const dictionary = dictionaries[code] || sk;
    const t = (key, fallback) => {
      const found = resolve(dictionary, key);
      return found ?? fallback ?? key;
    };
    return {
      code,
      setCode,
      t,
      languages: list,
      services: hydrateServices(dictionary),
      dictionary
    };
  }, [code]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useI18n = () => useContext(LanguageContext);
